import type { MjlUIConfig } from './config';
// window.__mjl type sudah didefinisikan di bus.ts

if (typeof window !== 'undefined') {
  window.__mjl ??= {};
  if (window.__mjl.config === undefined) {
    window.__mjl.config = null as unknown;
  }
}

export function setConfig(config: MjlUIConfig): void {
  if (typeof window !== 'undefined') {
    window.__mjl!.config = config as unknown;
  }
}

export function getConfig(): MjlUIConfig | null {
  if (typeof window !== 'undefined') {
    return (window.__mjl!.config as MjlUIConfig | null | undefined) ?? null;
  }
  return null;
}

export function clearConfig(): void {
  if (typeof window !== 'undefined') {
    window.__mjl!.config = null as unknown;
  }
}
